<template>
    <div class="accommodation">
  
      <div class="title-button">
  
        <h1>Services Type</h1>
  
      </div>
      
      <div class="row"> 
        <div class="col-md-6">
          <div class="box">
            <div class="row">
              <div class="col-md-12">
                <form @submit.stop.prevent="doSearch" class="box__header form--inline">
                  <input v-model="quickSearch" type="search" placeholder="Quick search">
                  <button class="button button--small" type="submit">Search</button>
                </form>
                <vdtnet-table
                  ref="table"
                  :fields="fields"
                  :opts="options"
                  @edit="doAlertEdit"
                  @delete="doAlertDelete"
                  >
                </vdtnet-table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <form class="form" v-on:submit.prevent="handleServiceType">
            <div class="box p-3">
              <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="form-label" for="service_name">Service Name</label>
                      <input type="text" class="form-control" name="service_name" id="service_name" v-model="serviceDetail.service_name" placeholder="Service Name">
                    </div>
                  </div>
              </div>
              <div class="row mt-3">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="form-label" for="service_code">Service Code</label>
                      <input type="text" class="form-control" name="service_code" id="service_code" v-model="serviceDetail.service_code"  placeholder="Service Code">
                    </div>
                  </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12">
                  <div class="form-submit-inline">
                    <button type="submit" class="button" v-if="userRole == 1">
                      <span> {{ (serviceDetail.flag == 'add' ? 'Add' : 'Edit') }} Service type </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import 'datatables.net'
  import 'datatables.net-select'
  import VdtnetTable from 'vue-datatables-net'
  
  export default {
    name: 'ServiceTypeIndex',
    components: {
      VdtnetTable
    },
    data() {
      return {
        options: {
          ajax: {
            url: this.$api + 'service-types/table',
            'headers': {
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
            }
          },
          responsive: false,
          processing: true,
          searching: true,
          searchDelay: 1500,
          destroy: true,
          ordering: true,
          lengthChange: true,
          serverSide: true,
          dom: 'rtlip',
          autoWidth: false,
          lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
          pageLength: 25,
        },
        fields: {
          service_name: { 
            label: 'Service Name',
          },
          service_code: { 
            label: 'Service Code',
          },
          actions: {
            sortable: false,
            label: ' ',
            render: (data, type, row) => {
              return `<a href="/serivce-type/edit/${ row.service_type_id }" data-action="edit" class="icon icon--more">Edit</a>`
            }
          },
          delete: {
            sortable: false,
            label: ' ',
            className: 'table-action',
            render: (data, type, row) => {
              if (this.userRole == 1) {
                return `<a href="/tour-managers/${ row.service_type_id }/delete" data-action="delete" class="icon icon--delete">Delete</a>`
              } else {
                return ''
              }
            }
          }
        },
        quickSearch: '',
        serviceTypes:[],
        serviceDetail: {
          flag:'add',
          service_name: null,
          service_code:null
        },
        userRole: localStorage.getItem("user_role")
      }
    },
    methods: {
      doSearch() {
        this.$refs.table.search(this.quickSearch)
      },
      doAlertEdit(data) {
        this.serviceDetail = {
          flag: 'edit',
          service_type_id:data.service_type_id,
          service_name:data.service_name
        }
      },
      doAlertDelete(data) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'service-types/' + data.service_type_id + '/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if(response.status) {
            this.$refs.table.reload()
            this.$notify({
              type: 'success',
              title: response.message
            });
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });
          } else {
            this.$notify({
              type: 'error',
              title: response.Error
            });
          }
          this.$store.dispatch('setLoadStatus')
        });
      },
      handleServiceType() {
        this.$store.dispatch('setLoadStatus')
        let formData = new FormData();

        // Iterate through the object
        for (const key in this.serviceDetail) {
          // Check if the property belongs to the object (not inherited)
          if (this.serviceDetail.hasOwnProperty(key) && this.serviceDetail[key]) {
            // Append key-value pair to the FormData object
            formData.append(key, this.serviceDetail[key]);
          }
        }
        fetch(`${this.$api}service-types/create`, {
            method: 'POST',
            body: formData,
            headers:{
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
            }
        })
        .then(res => res.json())
        .then(response => {
            this.errors = response.errors
            if(response.status) {
                this.$notify({
                    type: 'success',
                    title: response.message
                });
                this.serviceDetail = {
                  flag:'add',
                }
                // Reload Table
                this.$refs.table.search(this.quickSearch)
            } else if (response.errors) {
                this.$notify({
                    type: 'error',
                    title: response.message
                });
            }
            this.$store.dispatch('setLoadStatus')
        });
      }
    }
  }
  
  </script>
  